export default __webpack_public_path__ + "../img/9a9c34c377a9c7abed537a620eff9cbd.png";